import { useEffect } from 'react'

export type ToastType = 'success' | 'warning' | 'error'

const ALERT_CLASS: Record<ToastType, string> = {
  success: 'alert-success',
  warning: 'alert-warning',
  error: 'alert-error',
}

interface ToastProps {
  type: ToastType
  message: string
  onDismiss: () => void
  durationMs?: number
}

const Toast = ({ type, message, onDismiss, durationMs = 5000 }: ToastProps) => {
  useEffect(() => {
    const timeout = setTimeout(onDismiss, durationMs)
    return () => clearTimeout(timeout)
  }, [onDismiss, durationMs])

  return (
    <div className="toast toast-end z-50">
      <div role="status" className={`alert ${ALERT_CLASS[type]}`}>
        <span className="max-w-md">{message}</span>
        <button
          type="button"
          className="btn btn-ghost btn-xs"
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          ✕
        </button>
      </div>
    </div>
  )
}

export { Toast }
